import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "./api";
import { useAuth } from "./AuthContext";
import { Spinner } from "./ui";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const finish = async () => {
      try {
        const existing = localStorage.getItem("br_token");
        const r = await api.post("/auth/google/session", {
          session_id: sid,
          guest_token: existing || undefined,
        });
        setSession(r.data.access_token, r.data.user);
        navigate("/app", { replace: true, state: { user: r.data.user } });
      } catch {
        navigate("/auth", { replace: true });
      }
    };
    finish();
  }, []);

  return (
    <div className="min-h-screen bg-[#1F1E1B] flex items-center justify-center">
      <Spinner label="Signing you in…" />
    </div>
  );
}
